import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export default class AggregatedUser extends Model {
  [Type] = 'aggregated-user' as const;

  @attr('number') declare biBenchmarkingPropertyCount: number;
  @attr('string') declare email: string;
  @attr('string') declare firstName: string;
  @attr('string') declare lastActive: string | null;
  @attr('string') declare lastName: string;
  @attr('number') declare rateInsightPropertyCount: number;
}
